import * as z from "zod/v4";

export const applyOptimizationJobDrafts = {
  name: "applyOptimizationJobDrafts" as const,
  input: z.object({
    jobId: z.bigint(),
    fields: z.array(z.string()).optional(),
  }),
  output: z.void(),
};
